<template>
<v-row>
    <v-col cols="8">
        Period
        <v-slider
            ticks
            :step="step"
            :min="step"
            :max="step * 10"
            thumb-label
            v-model="v"
            @change="update"
        >
        </v-slider>
    </v-col>
    <v-col cols="4" class="mt-0 pt-0">
        <v-text-field
            type="number"
            v-model="te"
            @change="update"
            class="nn"
        />
    </v-col>
</v-row>
</template>
<script>
export default {
    name: 'DateSlider',
    props: [
        'value',
        'step'
    ],
    methods: {
        update(n) {
            this.v = n
            this.te = n
            this.$emit('input', this.v)
        }
    },
    watch: {
        step(n) {
            this.update(n)
        }
    },
    data: () => {
        return {
            v: '',
            te: ''
        }
    },
    mounted() {
        this.update(this.step)
    }

}
</script>
<style scoped>

.nn {
    max-width: 60px;
}

.nn >>> input {
    text-align: center;
}

</style>